import { PickupPoint } from "./../types/pickup-point.enum";
import { AxiosInstance } from "axios";
import {
  DefaultUserShippingData,
  ShippingCourierData,
  User,
  UserLoginData,
  UserRecoverPasswordData,
  UserRegisterData,
  UserRemindData,
  WithToken,
  ToggleName,
} from "@/types";
import { csrfToken } from "@/features/user/store";
import { CompleteRegistrationFormData } from "@/features/user/social-login/models";

export class UserApi {
  constructor(private axios: AxiosInstance) {}

  completeRegistration(data: CompleteRegistrationFormData): Promise<void> {
    return this.axios.put("/user/complete_registration", data);
  }

  getCurrentUser(): Promise<WithToken<User>> {
    return this.axios.get<WithToken<User>>("/user/current").then((r) => r.data);
  }

  getFeatureToggles(): Promise<ToggleName[]> {
    return this.axios
      .get<ToggleName[]>("/user/feature-toggles")
      .then((r) => r.data);
  }

  login(data: UserLoginData): Promise<WithToken<User>> {
    return this.axios
      .post<WithToken<User>>("/login", { ...data, remember: true })
      .then((r) => r.data);
  }

  remind(data: UserRemindData): Promise<void> {
    return this.axios.post("/forgot-password", data);
  }

  recoverPassword(data: UserRecoverPasswordData): Promise<void> {
    return this.axios.post("/reset-password", data);
  }

  logout(): Promise<void> {
    return this.axios.post("/logout", { _token: csrfToken.value });
  }

  register(data: UserRegisterData): Promise<WithToken<User>> {
    return this.axios
      .post<WithToken<User>>("/register", data)
      .then((r) => r.data);
  }

  agreePolicy(): Promise<void> {
    return this.axios.post(`/user/agree_policy`, {});
  }

  getDefaultShippingData(): Promise<DefaultUserShippingData> {
    return this.axios
      .get<{
        LPX_HOME?: Partial<ShippingCourierData>;
        LPX_DROP?: Partial<{
          name: string;
          phone: string;
          location: {
            terminalId: string;
            terminalName: string;
          };
        }>;
        OMNIVA_DROP?: Partial<{
          name: string;
          phone: string;
          location: {
            terminalId: string;
            terminalName: string;
          };
        }>;
      }>("/user/shippingAddresses")
      .then(({ data: response }) => {
        const data: DefaultUserShippingData = {};
        if (response.LPX_HOME) {
          data.courier = response.LPX_HOME;
        }

        if (response.LPX_DROP) {
          data[PickupPoint.LPExpress] = {
            ...response.LPX_DROP,
            location: response.LPX_DROP.location
              ? {
                  id: Number(response.LPX_DROP.location.terminalId),
                  text: response.LPX_DROP.location.terminalName,
                }
              : undefined,
          };
        }

        if (response.OMNIVA_DROP) {
          data[PickupPoint.Omniva] = {
            ...response.OMNIVA_DROP,
            location: response.OMNIVA_DROP.location
              ? {
                  id: Number(response.OMNIVA_DROP.location.terminalId),
                  text: response.OMNIVA_DROP.location.terminalName,
                }
              : undefined,
          };
        }

        return data;
      });
  }
}
